import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { format } from 'date-fns'
import { array, fallback, object, optional, string } from 'valibot'

import { AnalyticsPage } from '@/analytics/components/Analytics/AnalyticsPage'
import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { METRICS_MIN_DATE } from '@/core/constants/constants'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

const defaultValues = {
  startDate: METRICS_MIN_DATE,
  endDate: format(new Date(), 'yyyy-MM-dd'),
}

const AnalyticsQueryParamsSchema = object({
  userState: fallback(optional(string()), undefined),
  userType: fallback(optional(string()), undefined),
  startDate: fallback(
    optional(string(), defaultValues.startDate),
    defaultValues.startDate,
  ),
  endDate: fallback(
    optional(string(), defaultValues.endDate),
    defaultValues.endDate,
  ),
  userGroups: fallback(optional(array(string())), undefined),
  departments: fallback(optional(array(string())), undefined),
})

export const Route = createFileRoute('/company/_management/analytics')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-analytics',
        }),
      },
    ],
  }),
  component: RouteComponent,
  validateSearch: AnalyticsQueryParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
})
function RouteComponent() {
  return (
    <CompanyPage>
      <AnalyticsPage />
    </CompanyPage>
  )
}
